var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group mr-3"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"text"},on:{"keyup":_vm.changeInput}}),_c('i',{staticClass:"bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }